module.exports = __webpack_public_path__ + "img/full-service.a652fc91.svg";